import { useState, useEffect} from 'react';
import MercatorProjection from '../config/mercatorProjection';

/**
 * 超印刷モーダルコンポーネント
 */
let isSuperPrintReview = false;
const PrintMapSuper = ({
  isPrintMapSuperOpen,
  setIsPrintMapSuperOpen,
  mapConfig,
  map,
  isOtherPanelOpen,

}) => {

  const [currentCenter, setCurrentCenter] = useState(null);
  const [currentZoom, setCurrentZoom] = useState(mapConfig.zoom);
  const [paperSize, setPaperSize] = useState('a4');
  const [gridWidth, setGridWidth] = useState(1);
  const [gridHeight, setGridHeight] = useState(1);
  const [orientation, setOrientation] = useState('p');
  const handleOrientationChange = (e) => {setOrientation(e.target.value); isSuperPrintReview=false;};

  const size = {
    a4p: {
      name: 'a4p',
      w: 580,
      h: 820
    },
    a4l: {
      name: 'a4l',
      w: 820,
      h: 580
    },
    a3p: {
      name: 'a3p',
      w: 820,
      h: 1160
    },
    a3l: {
      name: 'a3l',
      w: 1160,
      h: 820
    },
    b5p: {
      name: 'b5p',
      w: 500,
      h: 706
    },
    b5l: {
      name: 'b5l',
      w: 706,
      h: 500
    },
    b4p: {
      name: 'b4p',
      w: 706,
      h: 1000
    },
    b4l: {
      name: 'b4l',
      w: 1000,
      h: 706
    }
  }

  let layerId = "super-print-rectangles";

  // 地図上に表示した超印刷のレイヤーを削除する
  const removeSuperPrintLayer = () => {
    if(map){
      if(map.getLayer(layerId)) map.removeLayer(layerId);
      if(map.getSource(layerId)) map.removeSource(layerId);
    }
  }

  // 地図のレイヤースタイルが変更された時の処理
  // ※なんでこんなことするかと言うとmap.setStyle()するとレクタングルのlayerが削除されてしまうmapLibre仕様なのでLayerを再描画する
  useEffect(() => {
    if (mapConfig.style && map) {
      // スタイル適用後にレクタングルなどのレイヤーを再描画
      map.once('idle', () => {
        isSuperPrintReview = false; // isSuperPrintReviewフラグを落として次の再帰でLayerの再描画する
      });
    }
  }, [mapConfig.style, map]);

  // 超印刷フラグが閉じられたときは、地図上のプレビュー表示を消してアーリーリターン
  if (!isPrintMapSuperOpen){ 
    removeSuperPrintLayer();
    isSuperPrintReview = false;
    return null
  }

  // 超印刷パネルが開いていて、他のパネルが開かられたら超印刷パネルを閉じる
  if(isPrintMapSuperOpen && isOtherPanelOpen){
    setIsPrintMapSuperOpen(false);
  }

  // 用紙サイズ変更
  const handlePaperSizeChange = (e) => {setPaperSize(e.target.value); isSuperPrintReview=false;};

  const execSuperPrint = () => {
    // 超印刷のURLを作成する
    let url = `${process.env.REACT_APP_BASE_URL}/p/full/`
    let {lat, lng} = currentCenter;
    // 現行の超印刷ページは0.xx単位でzoomレベルを決められないので少数切り捨て+1する
    // 超印刷印刷ページは19までしか許容してないので、ズームレベルが最大の19の場合は19で扱う
    let level = currentZoom >= 19? 19: Math.floor(currentZoom) + 1;
    let num = `${gridWidth}x${gridHeight}`;
    let size = `${paperSize}${orientation}`;

    url += `?usr=atlas_org&lat=${lat}&lon=${lng}&level=${level}&num=${num}&size=${size}`;
    window.open(url, '_blank');
  }

  // 初期読み込みの地点を保存して、
  // 次のレンダーで超印刷プレビューをレンダリングする
  if(!currentCenter) {
    setCurrentCenter(map.getCenter());
    setCurrentZoom(map.getZoom());
    return;
  }

  // 超印刷プレビューの紙1枚のレクタングルをGeoJSON形式で返す
  const makeRectangleCoordinates = (minLat, minLng, maxLat, maxLng) =>{
    let coordinates =  [[
      [
        minLng,  // 西
        maxLat  // 北
      ],
      [
        minLng, // 西
        minLat // 南
      ],
      [
        maxLng, // 東
        minLat // 南
      ],
      [
        maxLng, // 東
        maxLat // 北
      ],
      [
        minLng,  // 西
        maxLat  // 北 ※元の位置に戻る
      ]
    ]];
    return {
      "type": "Feature",
      "geometry": {
        coordinates,
        "type": "Polygon",
      }
    }
  }

  // 超印刷プレビューを表示する
  const renderSuperPrintReview = ()=>{
    // 用紙サイズを取得
    let {w, h} = size[`${paperSize}${orientation}`];

    // 設定された中心点
    let {lat, lng} = currentCenter;

    let features = [];
    let leftOffset = -(w/2) * gridWidth;
    let topOffset = -(h/2) * gridHeight;
    let reviewZoom = currentZoom >= 19? 19: Math.floor(currentZoom) + 1; // 超印刷印刷ページは19までしか許容してないので、ズームレベルが最大の19の場合は19で扱う

    for(let i=0; i < gridHeight; i++){
      for(let i2=0; i2 < gridWidth; i2++){
        let west = leftOffset + (w * i2);
        let east = west + w;
        let north = topOffset + (h * i);
        let south = north + h;
        // 北西
        let {lat: minLat, lon: minLng} = MercatorProjection.getPixelDefferencePosition(
          lat,
          lng,
          reviewZoom,
          west,
          north
        );
        // 南東
        let {lat: maxLat, lon: maxLng} = MercatorProjection.getPixelDefferencePosition(
          lat,
          lng,
          reviewZoom,
          east,
          south
        );

        features.push(makeRectangleCoordinates(minLat, minLng, maxLat, maxLng));
      }
      
    }

    // レクタングルを作る
    removeSuperPrintLayer(); // 前のレイヤーを除去

    map.addSource(layerId, {
      type: 'geojson',
      data: {
        type: "FeatureCollection",
        features
      }
    });
    map.addLayer({
      id: layerId,
      type: "fill",
      source: layerId,
      layout: {},
      paint: {
          'fill-color': '#088',
          'fill-opacity': 0.3,
          'fill-outline-color': '#000'
      }
    });
    isSuperPrintReview = true;
  };

  // 超印刷の設定を初期値に戻す
  const resetSuperPrintSetting = () => {
    setCurrentCenter(null);
    setCurrentZoom(null);
    setPaperSize("a4");
    setGridWidth(1);
    setGridHeight(1);
    setOrientation("p");
    isSuperPrintReview = false;
  }

  // 印刷範囲を拡大/縮小する
  const changePrintRangeZoom = (zoom)=>{
    if(zoom < 5 || zoom > 19) return;
    setCurrentZoom(zoom);
    isSuperPrintReview=false;
  }

  // 超印刷のプレビューが表示されてない場合はプレビューを表示する
  // ※基本的に各種設定が変更されたらisSuperPrintReviewをfalseにしてプレビューを再描画させている
  if(!isSuperPrintReview){
    renderSuperPrintReview()
  }
  

  return (
    <div
      id="print-settings-modal" className={"super-print-modal"}
    >

      <div className="super-print-modal-content">
        <div className="print-panel-header">
          <h3>超印刷</h3>
          <button className="close-btn" id="close-print-modal" onClick={()=>{setIsPrintMapSuperOpen(false)}}>×</button>
        </div>

        <div className="print-panel-content">
          {/* <!-- 用紙設定 --> */}
          <div className="setting-group">
            <label className="setting-label">用紙サイズ</label>
            <select
              className="setting-select"
              id="paperSize"
              value={paperSize}
              onChange={handlePaperSizeChange}
            >
              <option value="a4">A4</option>
              <option value="a3">A3</option>
              <option value="b4">B4</option>
              <option value="b5">B5</option>
            </select>
          </div>

          {/* <!-- レイアウト設定 --> */}
          <div className="setting-group">
            <label className="setting-label">向き</label>
            <div className="radio-group">
              <label className="radio-label">
                <input
                  type="radio"
                  name="orientation"
                  value="p"
                  checked={orientation === 'p'}
                  onChange={handleOrientationChange}
                />
                <span className="radio-custom"></span>
                縦
              </label>
              <label className="radio-label">
                <input
                  type="radio"
                  name="orientation"
                  value="l"
                  checked={orientation === 'l'}
                  onChange={handleOrientationChange}
                />
                <span className="radio-custom"></span>
                横
              </label>
            </div>
          </div>

          {/* <!-- 印刷範囲設定 --> */}
          <div className="setting-group">
            <label className="setting-label">印刷範囲</label>
            <div className="grid-controls">
              <div className="grid-input-group">
                <label>横</label>
                <input
                  type="number"
                  id="gridWidth"
                  min="1"
                  max="10"
                  value={gridWidth}
                  onChange={(e) => {
                    setGridWidth(Math.max(1, Math.min(10, Number(e.target.value) || 1)));
                    isSuperPrintReview = false;
                  }}
                  className="grid-input"
                />
                <span>枚</span>
              </div>
              <div className="grid-input-group">
                <label>縦</label>
                <input
                  type="number"
                  id="gridHeight"
                  min="1"
                  max="10"
                  value={gridHeight}
                  onChange={(e) =>{
                    setGridHeight(Math.max(1, Math.min(10, Number(e.target.value) || 1)));
                    isSuperPrintReview = false;
                  }}
                  className="grid-input"
                />
                <span>枚</span>
              </div>
            </div>
            <div className="grid-controls">
              <button onClick={()=>{changePrintRangeZoom(currentZoom-1)}}>拡大</button>
              <button onClick={()=>{changePrintRangeZoom(currentZoom+1)}}>縮小</button>
            </div>
            <div className="total-pages">
              合計: <span id="totalPages">{gridWidth * gridHeight}</span>枚 (最大100枚)
            </div>
          </div>

          {/* <!-- アクションボタン --> */}
          <div className="action-buttons">
            <button
              className="btn btn-secondary"
              id="reset-print-settings"
              onClick={() => {
                setCurrentCenter(map.getCenter());
                isSuperPrintReview = false;
              }}
            >
              現在の中心を移動
            </button>
            <button
              className="btn btn-secondary"
              id="reset-print-settings"
              onClick={resetSuperPrintSetting}
            >
              設定をリセット
            </button>
            <button
              className="btn btn-primary"
              id="generate-print-pages"
              onClick={execSuperPrint}
            >
              印刷結果を確認する
            </button>
          </div>
        </div>
      </div>

    </div>
  );

}

export default PrintMapSuper;